import React, { useState, Fragment } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { PiPencilSimpleLine, PiTrashDuotone } from "react-icons/pi";
import DataTable from "react-data-table-component";
import { configData } from "../../../config/systemconfigurationconstants";
import UseLambdaInvocations from "../../../hooks/useLambdaInvocations";
import lambdaConfig from "../../../hooks/lambdaConfig";
import { ToastContainer, toast } from "react-toastify";
import { PiTrashThin, PiNotePencilBold } from "react-icons/pi";
import { IoAddCircle, IoTrashBin } from "react-icons/io5";
const UsecaseClientMap = ({ userDetails, userList, usecaseList, userRole }) => {
  const [userRights] = useState(JSON.parse(localStorage.getItem("UserRights")));
  const [rolesAndRights] = useState(JSON.parse(localStorage.getItem("RolesAndRights")));
  const { invokeLambda } = UseLambdaInvocations();

  const [selectedSecurityId, setSelectedSecurityId] = useState("");
  const [tableData, setTableData] = useState([]);
  const [editingRowId, setEditingRowId] = useState(null);
  const [editableData, setEditableData] = useState({});
  const [dotloader, setDotLoader] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [isEditableDropdowns, setIsEditableDropdowns] = useState(true);
  const [isGoClicked, setIsGoClicked] = useState(false);
  const [isAddDisabled, setIsAddDisabled] = useState(false);


  // 🔹 Flattened use case list
  const extractedUseCases = Array.isArray(usecaseList) ? usecaseList : [];

  // 🔹 Roles
  const roleOptions = userRole || [];

  const [clientOptions, setClientOptions] = useState([]);

  // 🔹 Delete row handler
  const handleDelete = async () => {
    setDotLoader(true);
    // if (rowToDelete) {
    //   const updatedData = tableData.filter(
    //     (row) => row.UserMapId !== rowToDelete.UserMapId
    //   );
    //   setTableData(updatedData);
    //   setRowToDelete(null);
    // }
    try {
      // const payloadRow = {
      //   UserMapId: updatedRow.UserMapId,
      //   UseCaseId: updatedRow.UseCaseId,
      //   ClientId: updatedRow.ClientId,
      //   RoleMasterId: updatedRow.RoleMasterId,
      //   IsDefault: updatedRow.IsDefault || false,
      // };

      const payload = {
        ...lambdaConfig,
        SecurityToken: localStorage.getItem("SecurityToken"),
        UserMapId: rowToDelete.UserMapId
      };

      const parsedBody = await invokeLambda(
        configData.DELETE_USER_MAPPING,
        payload
      );

      if (parsedBody.Status) {
        setTimeout(() => setDotLoader(false), 1000);
        getUsecaseClientMap();
        toast.success("Usecase-Client-Role combination deleted successfully", {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      else {
        getUsecaseClientMap();
        setTimeout(() => setDotLoader(false), 1000);
        toast.error("Usecase-Client-Role combination deleted failed.", {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch {
      getUsecaseClientMap();
      setTimeout(() => setDotLoader(false), 1000);
      toast.error("Usecase-Client-Role combination deleted failed.", {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  // 🔹 Delete confirmation popover
  const deletePopover = (
    <Popover id="popover-delete-confirmation">
      <Popover.Header as="h3">Delete Account</Popover.Header>
      <Popover.Body>
        Do you want to delete the User Account?
        <div className="mt-2 d-flex justify-content-end gap-2">
          {/* <Button variant="secondary" size="sm" onClick={() => setRowToDelete(null)}>
            No
          </Button> */}
          <Button variant="primary" size="sm" onClick={handleDelete}>
            <PiTrashThin className="shake-icon" style={{ fontSize: '16px' }} /> Delete
          </Button>
        </div>
      </Popover.Body>
    </Popover>
  );

  // 🔹 Fetch mapping details
  const getUsecaseClientMap = async () => {
    setDotLoader(true);
    setIsGoClicked(true);
    setIsAddDisabled(false);
    try {
      const parsedBody = await invokeLambda(configData.GET_USER_MAPPING_DETAILS, {
        ...lambdaConfig,
        SecurityToken: localStorage.getItem("SecurityToken"),
        UserSecurityId: selectedSecurityId,
      });

      if (parsedBody.Status) {
        setTableData(parsedBody.UserMappingInfo);
        setTimeout(() => setDotLoader(false), 1000);
      } else {
        setTimeout(() => setDotLoader(false), 1000);
      }
    } catch {
      setTimeout(() => setDotLoader(false), 1000);
    }
  };

  // 🔹 Handle Edit
  const handleEditClick = (row) => {
    if (hasRightsToCreateEditDeleteUsers()) {
      setEditingRowId(row.UserMapId);

      const selectedUseCase = extractedUseCases.find(
        (u) => u.UseCaseID === row.UseCaseId
      );

      const clientList = selectedUseCase?.Client || [];

      // make sure both ClientId and ClientName are preserved
      const selectedClient = clientList.find(
        (c) => c.ClientID === row.ClientId
      );

      setEditableData({
        ...row,
        UseCaseId: row.UseCaseId || "",
        UseCaseName: selectedUseCase
          ? selectedUseCase.UseCaseName
          : row.UseCaseName || "",
        ClientId:
          row.ClientId || (selectedClient ? selectedClient.ClientID : ""),
        ClientName: selectedClient
          ? selectedClient.ClientName
          : row.ClientName || "",
        RoleMasterId: row.RoleMasterId || "",
        RoleName: row.RoleName || "",
      });

      setClientOptions(clientList);
      setIsEditableDropdowns(false);
    } else {
      toast.warning("Not authorized to edit mapping", {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };


  // 🔹 Handle field changes (keeps both ID + Name in state)
  const handleChange = (field, value) => {
    setEditableData(prev => {
      let updated = { ...prev, [field]: value };

      if (field === "UseCaseId") {
        const selUseCase = extractedUseCases.find(x => x.UseCaseID == value);
        const clientList = selUseCase ? selUseCase.Client : [];
        setClientOptions(clientList);

        // Only reset IDs, not store names
        updated = {
          ...updated,
          UseCaseId: value,
          UseCaseName: selUseCase ? selUseCase.UseCaseName : "",
          ClientId: "",
          ClientName: "",
          RoleMasterId: "",
          RoleName: ""
        };
      }

      if (field === "ClientId") {
        // no need to store ClientName
        const selClient = clientOptions.find(c => c.ClientID == value);
        updated = {
          ...updated,
          ClientId: value,
          ClientName: selClient ? selClient.ClientName : "",
          RoleMasterId: "",
          RoleName: ""
        };
      }
      if (field === "RoleMasterId") {
        const selRole = roleOptions.find(r => r.RoleMasterId == value);
        updated = {
          ...updated,
          RoleMasterId: value,
          RoleName: selRole ? selRole.RoleName : ""
        };
      }
      return updated;
    });
  };


  // 🔹 Handle Save (send only IDs to API)
  const handleSave = async () => {
    setDotLoader(true);

    const updatedRow = { ...editableData };

    if (editingRowId === "new") {
      updatedRow.UserMapId = null;
      setTableData((prev) => [updatedRow, ...prev]);
    } else {
      setTableData((prev) =>
        prev.map((row) => (row.UserMapId === editingRowId ? updatedRow : row))
      );
    }

    setEditingRowId(null);
    setEditableData({});
    setIsAddDisabled(false);

    try {
      const payloadRow = {
        UserMapId: updatedRow.UserMapId,
        UseCaseId: updatedRow.UseCaseId,
        ClientId: updatedRow.ClientId,
        RoleMasterId: updatedRow.RoleMasterId,
        IsDefault: updatedRow.IsDefault || false,
      };

      const payload = {
        ...lambdaConfig,
        SecurityToken: localStorage.getItem("SecurityToken"),
        UserSecurityId: selectedSecurityId,
        UserJSON: { UserMappingInfo: [payloadRow] },
      };

      const parsedBody = await invokeLambda(
        configData.CREATE_MODIFY_USER_MAPPING,
        payload
      );

      if (parsedBody.Status) {
        getUsecaseClientMap();
        setTimeout(() => setDotLoader(false), 1000);
        toast.success(
          "Usecase-Client-Role combination is updated successfully",
          {
            position: "bottom-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          }
        );
      }
      else {
        getUsecaseClientMap();
        setTimeout(() => setDotLoader(false), 1000);
        toast.error("Usecase-Client-Role combination is updated failed", {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch {
      getUsecaseClientMap();
      setTimeout(() => setDotLoader(false), 1000);
      toast.error("Usecase-Client-Role combination is updated failed", {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  // 🔹 Cancel editing
  const handleCancel = () => {
    setEditingRowId(null);
    setEditableData({});
    setIsEditableDropdowns(true);
    setIsAddDisabled(false);
  };

  // 🔹 Add new row
  const handleAdd = () => {
    const newRow = {
      UserMapId: null,
      UseCaseId: "",
      UseCaseName: "",
      ClientId: "",
      ClientName: "",
      RoleMasterId: "",
      RoleName: "",
      IsDefault: false,
    };

    setClientOptions([]);
    setEditableData(newRow);
    setEditingRowId("new");
    setIsEditableDropdowns(true);
    setIsAddDisabled(true); //Disable Add button
  };
  const handleToggleDefault = async (row) => {
    setDotLoader(true)
    const updatedRow = { ...row, IsDefault: !row.IsDefault };

    // update state immediately for UI responsiveness
    setTableData(prev =>
      prev.map(r =>
        r.UserMapId === row.UserMapId ? updatedRow : r
      )
    );

    try {
      const payloadRow = {
        UserMapId: updatedRow.UserMapId,
        UseCaseId: updatedRow.UseCaseId,
        ClientId: updatedRow.ClientId,
        RoleMasterId: updatedRow.RoleMasterId,
        IsDefault: updatedRow.IsDefault,
      };
      const payload = {
        ...lambdaConfig,
        SecurityToken: localStorage.getItem("SecurityToken"),
        UserSecurityId: selectedSecurityId,
        UserJSON: { UserMappingInfo: [payloadRow] },
      };

      const parsedBody = await invokeLambda(
        configData.CREATE_MODIFY_USER_MAPPING,
        payload
      );

      // optionally refresh after save
      if (parsedBody.Status) {
        getUsecaseClientMap();
        setTimeout(() => setDotLoader(false), 1000);
        toast.success(
          "Usecase-Client-Role combination is updated successfully",
          {
            position: "bottom-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          }
        );
      }
      else {
        getUsecaseClientMap();
        setTimeout(() => setDotLoader(false), 1000);
        toast.error("Usecase-Client-Role combination is updated failed", {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch {
      getUsecaseClientMap();
      setTimeout(() => setDotLoader(false), 1000);
      toast.error("Usecase-Client-Role combination is updated failed", {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  // 🔹 Table Columns
  const columns = [
    {
      name: "UseCase",
      selector: (row) => row?.UseCaseName || "",
      cell: (row) =>
        row.UserMapId === editingRowId ? (
          <Form.Select
            size="sm"
            className="mt-1 mb-1"
            disabled={!isEditableDropdowns}
            value={editableData.UseCaseId || ""}
            onChange={e => handleChange("UseCaseId", e.target.value)}
          >
            <option value="">-- Select Use Case --</option>
            {extractedUseCases.map(uc => (
              <option key={uc.UseCaseID} value={uc.UseCaseID}>
                {uc.UseCaseName}
              </option>
            ))}
          </Form.Select>

        ) : (
          row?.UseCaseName || ""
        ),
      sortable: true,
    },
    {
      name: "Client",
      selector: (row) => row?.ClientName || "",
      cell: (row) =>
        row.UserMapId === editingRowId ? (
          <Form.Select
            size="sm"
            className="mt-1 mb-1"
            disabled={!isEditableDropdowns}
            value={editableData.ClientId || ""}
            onChange={e => handleChange("ClientId", e.target.value)}
          >
            <option value="">-- Select Client --</option>
            {clientOptions.map(client => (
              <option key={client.ClientID} value={client.ClientID}>
                {client.ClientName}
              </option>
            ))}
          </Form.Select>
        ) : (
          row?.ClientName || ""
        ),
      sortable: true,
    },
    {
      name: "Roles",
      selector: (row) => row?.RoleName || "",
      cell: (row) =>
        row.UserMapId === editingRowId ? (
          <Form.Select
            size="sm"
            className="mt-1 mb-1"
            value={editableData.RoleMasterId || ""}
            onChange={(e) => handleChange("RoleMasterId", e.target.value)}
          >
            <option value="">-- Select Role --</option>
            {roleOptions.map((role) => (
              <option key={role.RoleMasterId} value={role.RoleMasterId}>
                {role.RoleName}
              </option>
            ))}
          </Form.Select>
        ) : (
          row?.RoleName || ""
        ),
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {editingRowId === row.UserMapId ? (
            <>
              <Button variant="success" size="sm" onClick={handleSave}>
                Save
              </Button>
              <Button variant="secondary" size="sm" onClick={handleCancel}>
                Cancel
              </Button>
            </>
          ) : (
            <>

              <div onClick={() => handleEditClick(row)} className='icon edit'>
                <PiNotePencilBold />
              </div>

              {hasRightsToCreateEditDeleteUsers() && (<OverlayTrigger
                trigger="click"
                placement="left"
                overlay={deletePopover}
                rootClose
                onToggle={(show) => {
                  if (show) setRowToDelete(row);
                }}
              >
                <div className="icon delete">
                  <IoTrashBin />
                </div>
              </OverlayTrigger>)}
              {!hasRightsToCreateEditDeleteUsers() && (
                <div className="icon delete" onClick={notAuthorized}>
                  <IoTrashBin />
                </div>
              )}

              {/* <Form.Check type="switch" checked={row.IsDefault} /> */}
              {hasRightsToCreateEditDeleteUsers() && (<Form.Check
                type="switch"
                checked={row.IsDefault}
                onChange={() => handleToggleDefault(row)}
              />)}
              {!hasRightsToCreateEditDeleteUsers() && (<Form.Check
                disabled
                type="switch"
                checked={row.IsDefault}
                onClick={notAuthorized}
              />)}
            </>
          )}
        </div>
      ),
    },
  ];

  // 🔹 Dynamic table height
  const screenWidth = window.innerWidth;
  let minHeight;
  if (screenWidth === 1920) minHeight = "626px";
  else if (screenWidth === 1680) minHeight = "595px";
  else if (screenWidth === 1600) minHeight = "448px";
  // else if (screenWidth === 1280) minHeight = "575px";
  else minHeight = "calc(100vh - 314px)";

  const customStyles = {
    table: {
      style: {
        minHeight,
        backgroundColor: "white",
        overflowY: "auto",
      },
    },
  };

  // 🔹 SecurityId selection
  const getUserMappingDetails = (e) => {
    const selectedId = e.target.value;
    setSelectedSecurityId(selectedId);
    setIsGoClicked(false);        // hide the table until "Go" is clicked again
    setTableData([]);             // clear previous user's data
    setEditingRowId(null);        // reset editing state
    setEditableData({});
    setIsAddDisabled(false);
  };
  const hasRightsToCreateEditDeleteUsers = () => {
    if (rolesAndRights !== null) {
      let rightID = rolesAndRights.AllRights.find((el) => el.RightType.trim() == "CREATE_EDIT_DELETE_USERS")?.RightId;
      if(userRights.some(el => el.RightId == rightID)) {
        return userRights.find((el) => el.RightId == rightID)?.RightValue == 1 ? true : false;
      }
    }
  };

  const notAuthorized = () => {
    toast.warning("Not authorized to edit mapping", {
      position: "bottom-center",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  return (
    <Fragment>

      <Row>
        <Col sm={4}>
          {/* <Form.Select size="sm" className="mb-1" onChange={getUserMappingDetails} value={selectedSecurityId}>
            <option disabled value="">-- Select User --</option>
            {userList &&
              userList.map((user, index) => (
                <option key={index} value={user.SecurityId}>
                  {user.UserName}
                </option>
              ))}
          </Form.Select> */}
          <Form.Select
            size="sm"
            className="mb-1"
            onChange={getUserMappingDetails}
            value={selectedSecurityId}
          >
            <option disabled value="">
              -- Select User --
            </option>
            {userList && userList.length > 0 ? (
              [...userList]
                .sort((a, b) => a.UserName.localeCompare(b.UserName))
                .map((user) => (
                  <option key={user.SecurityId} value={user.SecurityId}>
                    {user.UserName}
                  </option>
                ))
            ) : (
              <option disabled>No users found</option>
            )}
          </Form.Select>

        </Col>
        <Col sm={1} className="d-flex align-items-center">
          <Button variant="primary" size="sm" disabled={selectedSecurityId == ""} onClick={getUsecaseClientMap}>
            Go
          </Button>
        </Col>
        <Col sm={7} className="d-flex align-items-center justify-content-end">
          {isGoClicked && (
            <Button
              variant="primary"
              size="sm"
              disabled={isAddDisabled}
              onClick={handleAdd}
            >
              <IoAddCircle
                className="bounce-hover"
                style={{ fontSize: "15px", color: "#fff" }}
              />{" "}
              Add
            </Button>
          )}


        </Col>
      </Row>

      <Row>
        <Col sm={12}>
          {dotloader ? (
            <div className="loader-wrapper">
              <div className="loader"></div>
            </div>
          ) : isGoClicked ? (
            <DataTable
              columns={columns}
              data={
                editingRowId === "new"
                  ? [{ ...editableData, UserMapId: "new" }, ...tableData]
                  : tableData
              }
              pagination
              dense
              customStyles={customStyles}
            />
          ) : null}

        </Col>
      </Row>
    </Fragment>
  );
};

export default UsecaseClientMap;
